<template>
  <wo-card v-if="value" :title="title">
    <slot name="actions" slot="actions" />

    <wo-properties v-if="modFlags" mod-bordered mod-horizontal>
      <wo-properties-label><wo-label v-t="'salespoint.channel'" /></wo-properties-label>
      <wo-properties-value><po-display :value="value.channel" />&nbsp; (<po-display :value="value.audience" />)</wo-properties-value>

      <template v-for="(group, i) in tagGroups">
        <wo-properties-label :key="group.type.id"><wo-label v-t="group.type.labelKey" /></wo-properties-label>
        <wo-properties-value :key="i">
          <wo-pill class="wo-pill--sm" v-for="tag in group.values" :key="tag.id"><po-display :value="tag" /></wo-pill>
        </wo-properties-value>
      </template>

      <wo-properties-label><wo-label v-t="'salespoint.published'" /></wo-properties-label>
      <wo-properties-value><po-display :value="!!value.published" /></wo-properties-value>
      <wo-properties-label><wo-label v-t="'salespoint.garageConcept'" /></wo-properties-label>
      <wo-properties-value><po-display :value="!!value.garage_concept" /></wo-properties-value>
    </wo-properties>

    <wo-properties v-if="modInfo" mod-bordered mod-horizontal mod-border-top>
      <wo-properties-label><wo-label v-t="'company.name'" /></wo-properties-label>
      <wo-properties-value><po-display :value="company" /></wo-properties-value>
      <wo-properties-label><wo-label v-t="'company.website'" /></wo-properties-label>
      <wo-properties-value><wo-link v-if="company.website" :href="company.website" target="_blank">{{ company.website }}</wo-link></wo-properties-value>
      <wo-properties-label><wo-label v-t="'company.email'" /></wo-properties-label>
      <wo-properties-value><po-email-link v-if="company.email" :value="company.email" /></wo-properties-value>
      <wo-properties-label><wo-label v-t="'company.phoneNumber'" /></wo-properties-label>
      <wo-properties-value>{{ company.phone_number }}</wo-properties-value>
      <template v-if="value.external_id">
        <wo-properties-label><wo-label v-t="'salespoint.externalId'" /></wo-properties-label>
        <wo-properties-value>{{ value.external_id }}</wo-properties-value>
      </template>
    </wo-properties>
  </wo-card>
</template>

<script>

import { SalesPoint, SalesPointTag } from '@/model/sales-point'

export default {
  props: {
    value: SalesPoint,
    tags: Array,
    modFlags: Boolean,
    modInfo: Boolean
  },
  computed: {
    company () { return this.value.company },
    title () {
      return this.$t(this.modFlags ? 'salespoint.flags' : 'general.info')
    },
    tagGroups () {
      return SalesPointTag.grouped(this.tags)
    }
  }
}
</script>
